import { font, uTextEllipsis } from '@approvalmax/ui';
import { Flex } from '@approvalmax/ui/src/components';
import { ui } from 'modules/common';
import styled from 'styled-components';

export const Avatar = styled(ui.Avatar)`
    cursor: pointer;
    flex: none;
`;

export const Name = styled.div`
    ${font(13, '#30373d')};
    line-height: 48px;
    ${uTextEllipsis};
    cursor: pointer;
`;

export const PaddedGrid = styled(Flex)`
    padding: 0 10px;
`;
